import {Box, useMediaQuery, useTheme} from "@mui/material";
import React from "react";

function BreakpointIndicator() {

    const theme = useTheme();
    const xs = useMediaQuery(theme.breakpoints.only('xs'));
    const sm = useMediaQuery(theme.breakpoints.only('sm'));
    const md = useMediaQuery(theme.breakpoints.only('md'));
    const lg = useMediaQuery(theme.breakpoints.only('lg'));
    const xl = useMediaQuery(theme.breakpoints.only('xl'));
    const x2l = useMediaQuery(theme.breakpoints.only('x2l'));
    const x3l = useMediaQuery(theme.breakpoints.only('x3l'));
    const x4l = useMediaQuery(theme.breakpoints.only('x4l'));
    const x5l = useMediaQuery(theme.breakpoints.only('x5l'));

    if (process.env.NODE_ENV !== 'development') return null;

    let text = 'xs';
    if (sm) text = 'sm';
    if (md) text = 'md';
    if (lg) text = 'lg';
    if (xl) text = 'xl';
    if (x2l) text = 'x2l';
    if (x3l) text = 'x3l';
    if (x4l) text = 'x4l';
    if (x5l) text = 'x5l';

    return (
        <Box sx={{
            position: 'fixed',
            bottom: 20,
            left: 20,
            bgcolor: 'primary.main',
            color: 'white',
            p: 1.5,
            borderRadius: '50%',
            width: 50,
            height: 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            fontWeight: 'bold',
            boxShadow: 3,
            textTransform: 'uppercase',
            pointerEvents: 'none',
            fontSize: '0.75rem'
        }}>
            {text}
        </Box>
    );
}
export default BreakpointIndicator;